import { Application, ApplicationRole } from './Application';
import { Session } from './Session';

export enum TimelineEventTypeEnum {
	EVENT = 'event',
	MILESTONE = 'milestone',
}

export type TimelineEvent = {
	id: number;
	summary: string;
	subtitle: string | null;
	intro: string | null;
	description: string | null;
	forApplicationRole: ApplicationRole | null;
	onlineMeetingUrl: string | null;
	type: TimelineEventTypeEnum;
	mandatory: boolean;
	requireConfirmation: boolean;
	dayDate: string;
	startAt: Date | null;
	endAt: Date | null;
	programId: number;
	participantLimit: number | null;
	createdAt: Date;
};

export enum TimelineEventItemTypeEnum {
	EVENT = 'event',
	MILESTONE = 'milestone',
	SESSION = 'session',
}

export type TimelineEventItem = { key: string } & Pick<
	TimelineEvent,
	| 'summary'
	| 'subtitle'
	| 'intro'
	| 'description'
	| 'forApplicationRole'
	| 'onlineMeetingUrl'
	| 'mandatory'
	| 'requireConfirmation'
	| 'dayDate'
	| 'startAt'
	| 'endAt'
	| 'participantLimit'
> & {
		eventId: number | null;
		type: TimelineEventItemTypeEnum;
		session?: Partial<Session> & {
			link: string;
		};
		currentParticipants: number | null;
		attendanceConfirmed: boolean | null;
		visits: {
			mentee: number;
			mentor: number;
			all: number;
		};
		participations: {
			mentee: number;
			mentor: number;
			all: number;
		};
	};

export type TimelineEventListPaginated = {
	items: TimelineEventItem[];
	meta: {
		page: number;
		hasNextPage: boolean;
		hasPrevPage: boolean;
	};
};

export type TimelineParticipationItem = {
	key: string;
	application: Application;
	confirmedAt: Date;
};
